import {
  SHOW_USER_LOADING,
  GET_USER_DETAILS,
  USER_ERROR,
  GET_USERS,
  // modification start - 05.24.2024 - maco-magsael-sc-643
  DELETE_USER,
  // modification end - 05.24.2024 - maco-magsael-sc-643
  GET_SHIPYARD_USERS,
  DELETE_SHIPYARD_USERS,
} from '../actions/types';

/**
 * maco-magsael-sc-643: Shipyard: New shipyard modifications
 * olain-tarcina-sc-745: Shipyard modifications
 *
 */

const initialState = {
  userlist: [],
  shipyarduserlist: [],
  userID: null,
  userdetails: null,
  userLoading: false,
  edituser: false,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_USER_LOADING:
      return {
        ...state,
        userLoading: true,
      };
    case GET_USERS:
      return {
        ...state,
        userlist: payload,
        userLoading: false,
      };
    // Modification start - 14.02.2025 - olain-tarcina-sc-745
    case GET_SHIPYARD_USERS:
      return {
        ...state,
        shipyarduserlist: payload,
        userLoading: false,
      };
    // Modification end - 14.02.2025 - olain-tarcina-sc-745
    case GET_USER_DETAILS:
      return {
        ...state,
        userdetails: payload,
        userLoading: false,
      };
    case USER_ERROR:
      return {
        ...state,
        error: payload,
        userLoading: false,
      };
    // modification start - 05.24.2024 - maco-magsael-sc-643
    case DELETE_USER:
      return {
        ...state,
        userlist: state.userlist.filter((user) => user._id !== payload),
        userLoading: false,
      };
    // modification end - 05.24.2024 - maco-magsael-sc-643
    case DELETE_SHIPYARD_USERS:
      return {
        ...state,
        shipyarduserlist: state.shipyarduserlist.filter(
          (user) => user._id !== payload
        ),
        userLoading: false,
      };
    default:
      return state;
  }
}
